import { IRedirectButtonData } from '../../../types/redirect-button';

export const toTariffData: IRedirectButtonData[] = [];

export const DEFAULT_TO_TARIFF_URL = 'https://wakadoo.pro/tarif';
